export class Label {
    constructor(
        public readonly Id: any,
        public readonly Name: string,
        public IsEnabled: boolean
    ) { }
}
